import { render, staticRenderFns } from "./ProtocolSearch.vue?vue&type=template&id=681c77ee&scoped=true"
import script from "./ProtocolSearch.vue?vue&type=script&lang=js"
export * from "./ProtocolSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681c77ee",
  null
  
)

export default component.exports